import { Button } from '@heroui/react';

export const ListControl = ({
  onSort,
  onFilter,
}: {
  onSort?: () => void;
  onFilter?: () => void;
}) => {
  return (
    <div className="flex flex-row justify-between items-center py-3">
      <Button
        onPress={onSort}
        variant="light"
        size="sm"
        className="text-[#222222]"
        endContent={
          <svg
            width="21"
            height="20"
            viewBox="0 0 21 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M13.833 4.375C14.0021 4.375 14.164 4.44352 14.2817 4.56491L17.615 8.00241C17.8553 8.25021 17.8492 8.64589 17.6014 8.88619C17.3536 9.12648 16.9579 9.12039 16.7177 8.87259L14.458 6.54233L14.458 15C14.458 15.3452 14.1782 15.625 13.833 15.625C13.4878 15.625 13.208 15.3452 13.208 15L13.208 6.54233L10.9484 8.87259C10.7081 9.12039 10.3124 9.12648 10.0646 8.88619C9.81678 8.64589 9.81069 8.25021 10.051 8.00241L13.3843 4.56491C13.502 4.44352 13.6639 4.375 13.833 4.375ZM7.16634 4.375C7.51152 4.375 7.79134 4.65482 7.79134 5L7.79134 13.4577L10.051 11.1274C10.2913 10.8796 10.687 10.8735 10.9348 11.1138C11.1826 11.3541 11.1887 11.7498 10.9484 11.9976L7.61503 15.4351C7.49731 15.5565 7.33544 15.625 7.16634 15.625C6.99725 15.625 6.83537 15.5565 6.71765 15.4351L3.38432 11.9976C3.14403 11.7498 3.15011 11.3541 3.39792 11.1138C3.64572 10.8735 4.0414 10.8796 4.2817 11.1274L6.54134 13.4577L6.54134 5C6.54134 4.65482 6.82116 4.375 7.16634 4.375Z"
              fill="#222222"
            />
          </svg>
        }
      >
        Популярные
      </Button>

      <Button
        variant="light"
        size="sm"
        className="text-[#222222]"
        onPress={onFilter}
        endContent={
          <svg
            width="21"
            height="20"
            viewBox="0 0 21 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M15.7087 5.8335C15.7087 7.55939 14.3095 8.9585 12.5837 8.9585C10.8578 8.9585 9.45866 7.55939 9.45866 5.8335C9.45866 4.10761 10.8578 2.7085 12.5837 2.7085C14.3095 2.7085 15.7087 4.10761 15.7087 5.8335ZM12.5837 7.7085C13.6192 7.7085 14.4587 6.86903 14.4587 5.8335C14.4587 4.79796 13.6192 3.9585 12.5837 3.9585C11.5481 3.9585 10.7087 4.79796 10.7087 5.8335C10.7087 6.86903 11.5481 7.7085 12.5837 7.7085Z"
              fill="#222222"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M5.29199 14.1668C5.29199 15.8927 6.6911 17.2918 8.41699 17.2918C10.1429 17.2918 11.542 15.8927 11.542 14.1668C11.542 12.4409 10.1429 11.0418 8.41699 11.0418C6.6911 11.0418 5.29199 12.4409 5.29199 14.1668ZM8.41699 16.0418C7.38146 16.0418 6.54199 15.2024 6.54199 14.1668C6.54199 13.1313 7.38146 12.2918 8.41699 12.2918C9.45253 12.2918 10.292 13.1313 10.292 14.1668C10.292 15.2024 9.45253 16.0418 8.41699 16.0418Z"
              fill="#222222"
            />
            <path
              d="M12.3753 14.1323C12.3753 13.7871 12.6551 13.5073 13.0003 13.5073H18.8337C19.1788 13.5073 19.4587 13.7871 19.4587 14.1323C19.4587 14.4774 19.1788 14.7573 18.8337 14.7573H13.0003C12.6551 14.7573 12.3753 14.4774 12.3753 14.1323Z"
              fill="#222222"
            />
            <path
              d="M8.00033 5.17393C8.3455 5.17393 8.62533 5.45375 8.62533 5.79893C8.62533 6.14411 8.3455 6.42393 8.00033 6.42393L2.16699 6.42393C1.82181 6.42393 1.54199 6.14411 1.54199 5.79893C1.54199 5.45375 1.82181 5.17393 2.16699 5.17393L8.00033 5.17393Z"
              fill="#222222"
            />
            <path
              d="M1.54199 14.1323C1.54199 13.7871 1.82181 13.5073 2.16699 13.5073H3.83366C4.17884 13.5073 4.45866 13.7871 4.45866 14.1323C4.45866 14.4774 4.17884 14.7573 3.83366 14.7573H2.16699C1.82181 14.7573 1.54199 14.4774 1.54199 14.1323Z"
              fill="#222222"
            />
            <path
              d="M18.8337 5.17393C19.1788 5.17393 19.4587 5.45375 19.4587 5.79893C19.4587 6.14411 19.1788 6.42393 18.8337 6.42393H17.167C16.8218 6.42393 16.542 6.14411 16.542 5.79893C16.542 5.45375 16.8218 5.17393 17.167 5.17393H18.8337Z"
              fill="#222222"
            />
          </svg>
        }
      >
        Фильтры
      </Button>
    </div>
  );
};
